import { useRef } from "react"

import gsap from "gsap"
import styled from "styled-components"

import useAnimation from "utils/useAnimation"

interface Props {
  children: React.ReactNode
  continuous?: boolean
  className?: string
}
const randomNumber = (min: number, max: number) => {
  return Math.ceil(gsap.utils.random(min, max))
}

const drawPath = (target: Element) => {
  const size = randomNumber(2, 6)
  const duration = randomNumber(1, 3)

  const tl = gsap.timeline({
    repeat: -1,
  })

  tl.fromTo(target, {
      drawSVG: `0% 0%`,
    },
    {
      drawSVG: `0% ${size}%`,
      ease: "linear",
      duration: 0.25,
    }, 0)
    .to(target, {
      duration,
      drawSVG: `${50 - size}% 50%`,
      ease: "linear",
    })
    .to(target, {
      duration: 0.5,
      drawSVG: `50% 50%`,
      ease: "linear",
    })

  return tl
}
export default function AnimatedPath({
  children,
  continuous = false,
  className = "",
}: Props) {
  const wrapper = useRef<HTMLDivElement>(null)

  useAnimation(() => {
    if (wrapper.current && children) {
      const allPaths = Array.from(wrapper.current.getElementsByTagName("path"))

      const tl = gsap.timeline({
        repeat: -1,
        repeatRefresh: true,
        scrollTrigger: {
          trigger: wrapper.current,
          start: "top 90%",
          end: "bottom top",
          toggleActions: continuous
            ? "play play play play"
            : "play pause resume pause",
        },
      })

      allPaths.forEach(path => tl.add(drawPath(path), randomNumber(2, 6) / 10))
    }
  }, [continuous, children])

  return (
    <SVGWrapper className={className} ref={wrapper}>
      {children}
    </SVGWrapper>
  )
}

const SVGWrapper = styled.div<{ topOffset?: string }>`
  position: relative;
  height: 100%;
  width: 100%;

  svg {
    height: 100%;
    width: 100%;
  }
`
